/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect,useState} from 'react'
import { useOutletContext, useNavigate, Link } from "react-router-dom";
import { Breadcrumb, List, Input, Spin, Menu, Space, Row, Col, Table, Switch, message, Modal, Divider, Select, DatePicker, Checkbox, Form, notification } from 'antd'
import { SearchOutlined, CaretDownOutlined, AlignLeftOutlined, PlusCircleOutlined, RollbackOutlined} from '@ant-design/icons';
import PageTitle from '../components/PageTitle';
import PageSearch from '../components/PageSearch';
import PageLayout from '../components/PageLayout';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { setReApplyData, setSignReocrdModalVisible, setViewFileModalVisible, setSignAndRejectModalVisible  } from '../redux/action/Components';
import types from '../redux/action/types';
import StampStatusObj from '../helper/StampStatusObj';
import { getLookupCodeList, queryAuditedStampTableList, queryStampTableList, reassignStamp, setGlobalSearchParams } from '../redux/action/Stamp';
import { getAllWiadvanceUsers } from '../redux/action/graph';
import InfiniteScroll from 'react-infinite-scroll-component';
import { MobileView, BrowserView, isMobile } from 'react-device-detect';

const { Option } = Select

const getMailList = (record) => [record?.applicant_mail, record?.agent_mail].filter(Boolean).join(",");

const buildReminderMailto = (record) => {
  const subject = encodeURIComponent(`[用印申請跟催] 請上傳留存檔案 - ${record?.stamp_no || ""}`);
  const body = encodeURIComponent(
    `您好，\n\n用印申請單 ${record?.stamp_no || ""}（${record?.document || ""}）目前仍在待上傳狀態，請協助上傳留存檔案。\n\n謝謝。`
  );

  return `mailto:${getMailList(record)}?subject=${subject}&body=${body}`;
};

const mergeByStampNo = (...lists) => {
  const map = new Map();
  lists.flat().filter(Boolean).forEach((item) => {
    map.set(item.stamp_no, item);
  });

  return Array.from(map.values()).sort((a, b) => (b.cr_date || 0) - (a.cr_date || 0));
};

const defaultPendingUploadParams = {
  stamp_type: ['pendingUpload'],
  next_auditor_mail: null,
  stamp_no: null,
  document: null,
  start_date: null,
  end_date: null,
  page_record_set: 10,
  page: 1
}

export default function StampPendingUpload(){

  const dispatch = useDispatch()
  const { currentUser } = useOutletContext();
  const isLoading = useSelector(state => state.globalSetting.isLoading)
  const navigate = useNavigate()
  const stampTableList = useSelector(state => state.Stamp.stampTableList)
  const tableProps = useSelector(state => state.Stamp.tableProps)
  const globalParams = useSelector(state => state.Stamp.globalParams)
  const [ pageSize, setPageSize ] = useState(10)
  const [ pageNow, setPageNow ] = useState(1)
  // 手機板
  const [ mobileTableData, setMobileTableData ] = useState([])
  const [ total, setTotal ] = useState(0)
  const [isMobileFirstRender, setIsMobileFirstRender] = useState(true)
  const [invoiceStampTypes, setInvoiceStampTypes] = useState([])
  const [ownerPendingUploadList, setOwnerPendingUploadList] = useState([])
  const [ownerPendingUploadTotal, setOwnerPendingUploadTotal] = useState(0)
  const [searchFilter, setSearchFilter] = useState(defaultPendingUploadParams)
  // 轉派（保管人在待上傳階段把單轉給同仁）
  const [reassignOpen, setReassignOpen] = useState(false)
  const [reassignRecord, setReassignRecord] = useState(null)
  const [reassignTarget, setReassignTarget] = useState(null)
  const [allUserList, setAllUserList] = useState([])

  useEffect(() => {
    if (allUserList.length === 0) {
      dispatch(getAllWiadvanceUsers()).then((resp) => {
        if (resp && resp.value) {
          setAllUserList(resp.value.map((item) => ({ label: item.displayName, value: item.mail })))
        }
      })
    }
  }, [])

  const openReassign = (record) => {
    setReassignRecord(record)
    setReassignTarget(null)
    setReassignOpen(true)
  }

  const onReassign = () => {
    if (!reassignTarget) {
      notification.warning({ message: '提醒', description: '請選擇要轉派的同仁' })
      return
    }
    dispatch(reassignStamp({
      stamp_no: reassignRecord?.stamp_no,
      auditor_name: currentUser.name,
      auditor_mail: currentUser.email,
      auditor_type: '印信保管人',
      audit_command: `轉派給 ${reassignTarget.label}`,
      next_auditor_name: reassignTarget.label,
      next_auditor_mail: reassignTarget.value,
    })).then((res) => {
      if (res && res.code === 200) {
        notification.success({ message: '成功', description: '已轉派給 ' + reassignTarget.label })
        setReassignOpen(false)
        dispatch(setGlobalSearchParams({ ...searchFilter, page: 1 }))
      } else {
        notification.error({ message: '失敗', description: res?.messages?.tw || '轉派失敗' })
      }
    }).catch((err) => {
      notification.error({ message: '失敗', description: '轉派失敗（' + (err?.response?.status || '連線/後端錯誤') + '），請確認後端 Reassign API 已部署' })
    })
  }

  const currentUserMail = currentUser?.email?.toLowerCase()
  const ownerStampTypeCodes = invoiceStampTypes
    .filter(item => String(item?.text1 || '').toLowerCase().split(',').map(mail => mail.trim()).includes(currentUserMail))
    .map(item => item.lookup_code)
  const displayTableList = mergeByStampNo(stampTableList, ownerPendingUploadList)
  const displayTotal = (Object.keys(tableProps).length !== 0 ? tableProps.count : 0) + ownerPendingUploadTotal

  //初次載入先初始化，避免載入之前搜尋資料
  useEffect(() =>{
    dispatch({ type: types.GET_STAMP_LIST, payload: {} })
    //存取當前位置
    localStorage.setItem('currentMenuItemsKey', 'StampPendingUpload')
    dispatch(setSignAndRejectModalVisible(false))
    dispatch(setSignReocrdModalVisible(false))
    dispatch(setViewFileModalVisible(false))
    dispatch(getLookupCodeList("stampType", "")).then((resp) => {
      setInvoiceStampTypes((resp || []).filter(item => item?.text3 === "direct"))
    })
    setIsMobileFirstRender(false)
    setTimeout(() => {
      //手機板
      if(isMobile){
        dispatch(setGlobalSearchParams(defaultPendingUploadParams))
      }
    }, 200);
  }, [])

  useEffect(() =>{
    if(Object.keys(tableProps).length !== 0){
      setPageNow(tableProps['page_now'])
      setPageSize(tableProps['page_size'])
      setTotal(tableProps['count'])
    }
  }, [tableProps])

  useEffect(() =>{
    dispatch(setReApplyData(null))
  },[])

  useEffect(() => {
    if (!ownerStampTypeCodes.length || Object.keys(searchFilter).length === 0) {
      setOwnerPendingUploadList([])
      setOwnerPendingUploadTotal(0)
      return
    }

    const selectedStamperTypes = searchFilter.stamper_type?.length
      ? ownerStampTypeCodes.filter(code => searchFilter.stamper_type.includes(code))
      : ownerStampTypeCodes

    if (!selectedStamperTypes.length) {
      setOwnerPendingUploadList([])
      setOwnerPendingUploadTotal(0)
      return
    }

    dispatch(queryAuditedStampTableList({
      ...searchFilter,
      stamp_type: ['pendingUpload'],
      stamper_type: selectedStamperTypes,
      page_record_set: searchFilter.page_record_set || pageSize,
      page: searchFilter.page || pageNow
    })).then((resp) => {
      setOwnerPendingUploadList(resp?.data || [])
      setOwnerPendingUploadTotal(resp?.pager_info?.count || 0)
    })
  }, [currentUserMail, searchFilter, invoiceStampTypes])

  // 以下是手機板function
  const loadMoreData = () =>{
    let newPage = pageNow + 1
    dispatch(setGlobalSearchParams({ ...globalParams, page_record_set: 10, page: newPage }))
  }

  useEffect(() =>{
    if(Object.keys(globalParams).length !== 0 && isMobile && !isMobileFirstRender){
      let tempTableData = JSON.parse(JSON.stringify(mobileTableData))

      if(globalParams.page === 1){
        setPageNow(1)
        tempTableData = []
        let content = document.getElementById('scrollableDiv')
        if(content){
          content.scrollTop = 0
        }
      }
      dispatch(queryStampTableList(globalParams)).then(resp =>{
        setMobileTableData(mergeByStampNo([...tempTableData, ...resp], ownerPendingUploadList))
      })
    }
  }, [globalParams, ownerPendingUploadList])

  useEffect(() => {
    setMobileTableData((prev) => mergeByStampNo(prev, ownerPendingUploadList))
  }, [ownerPendingUploadList])

  const canRemindUpload = (record) => {
    const isApplicant = record?.applicant_mail?.toLowerCase() === currentUserMail
    const isOwner = ownerStampTypeCodes.some(code => record?.stamp_type?.includes(code))

    return !isApplicant && isOwner && record?.stamp_status === 'pendingUpload'
  }

  const statusOptionList = [
    {
			label: '待上傳',
			value: 'pendingUpload'
    }
  ]
  
  const columns = [
    {
      title: '功能',
      align: 'center',
      dataIndex: 'action',
      key: 'action',
      // width: '15%',
      render:(_, record) =>{
        return(
          <Row justify='space-evenly'>
            <a onClick={() => navigate(`/Stamp/StampApplyViewPendingUpload/${record.stamp_no}`)}> 檢視 </a> 
            {
              record?.applicant_mail?.toLowerCase() === currentUser?.email?.toLowerCase() ?
              <>
                <Divider type='vertical' /><a onClick={() => navigate(`/Stamp/StampTempUpload/${record.stamp_no}`)}> 留存上傳 </a>
              </>
              : null
            }
            {
              canRemindUpload(record) ?
              <>
                <Divider type='vertical' /><a href={buildReminderMailto(record)}> 跟催 </a>
                <Divider type='vertical' /><a onClick={() => openReassign(record)}> 轉派 </a>
              </>
              : null
            }
          </Row>
        )
      }
    },
    {
      title: '編號',
      align: 'center',
      dataIndex: 'stamp_no',
      key: 'stamp_no',
    },
    {
      title: '申請人',
      align: 'center',
      dataIndex: 'applicant_name',
      key: 'applicant_name',
      width:'15%',
    },
    {
      title: '文件名稱',
      align: 'center',
      dataIndex: 'document',
      key: 'document',
      width:'15%',
    },
    {
      title: '申請日期',
      align: 'center',
      dataIndex: 'cr_date',
      key: 'cr_date',
      width:'15%',
      render:(_, record) =>{
        return moment.unix((record.cr_date/1000)).format('YYYY/MM/DD')
      }
    },
    {
      title: '狀態',
      align: 'center',
      dataIndex: 'stamp_status',
      key: 'stamp_status',
      render:(_, record) =>{
        return StampStatusObj[record.stamp_status]
      }
    }
  ];

  return(
    <PageLayout spinning={ isLoading !== 0 ? true : false }>
      <BrowserView>
        {/* 頁面目前位置 */}
        <Col span={24}>
          <Breadcrumb separator=">">
            <Breadcrumb.Item href='/'>WiAdvance EIP</Breadcrumb.Item>
            <Breadcrumb.Item href='/Stamp/StampApplication'>用印申請</Breadcrumb.Item>
            <Breadcrumb.Item >待上傳</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        {/* 頁面標題 */}
        <PageTitle>
          待上傳
        </PageTitle>
        {/* 頁面搜尋功能 */}
        <PageSearch
          statusList={statusOptionList}
          defaultSearchParams={['pendingUpload']}
          nextAuitor={null}
          onSearchParamsChange={setSearchFilter}
        />
        <Col span={24}
          style={{
            margin:'10px 0px',
          }}
        >
        </Col>
        <Col span={24}>
          <Table 
            pagination={{
              position: ['topRight', 'bottomRight'],
              total: displayTotal,
              pageSize: pageSize,
              current: pageNow
            }}
            dataSource={displayTableList}
            rowKey={(record) => record.stamp_no}
            onChange={(page) => {
              const nextParams = { ...searchFilter, page: page.current, page_record_set: pageSize }
              dispatch(setGlobalSearchParams(nextParams));
              setSearchFilter(nextParams);
              setPageNow(page.current)
            }}
            columns={columns}
            footer={(ele) => {
              return(
                <Col flex="auto">
                  <div style={{'textAlign':'end', 'margin':'8px', 'color':'#7C7C7C'}}>
                    共有{displayTotal}筆資料，每頁顯示
                    <Select
                      value={pageSize}
                      style={{
                        width: ( pageSize < 100 ? 60 : 70 ),
                        color:'#a5a5a5'
                      }}
                      bordered={false}
                      suffixIcon={<CaretDownOutlined />}
                      onChange={(e)=> {
                        const nextParams = { ...searchFilter, page_record_set: e, page: 1 }
                        dispatch(setGlobalSearchParams(nextParams));
                        setSearchFilter(nextParams);
                        setPageSize(e);
                        setPageNow(1)
                      }}
                    >
                      <Option value= {5}>5</Option>
                      <Option value= {10}>10</Option>
                      <Option value= {25}>25</Option>
                      <Option value= {50}>50</Option>
                      <Option value= {100}>100</Option>
                    </Select>
                    筆
                  </div>
                </Col>
              )
            }}
          />
        </Col>
      </BrowserView>
      <MobileView style={{ marginBottom: '115px' }}>
        {/* 頁面目前位置 */}
        <Col span={24}>
          <Breadcrumb separator=">">
            <Breadcrumb.Item href='/'>WiAdvance EIP</Breadcrumb.Item>
            <Breadcrumb.Item href='/Stamp/StampApplication'>用印申請</Breadcrumb.Item>
            <Breadcrumb.Item >待上傳</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        {/* 頁面標題 */}
        <PageTitle>
          待上傳
        </PageTitle>
        {/* 頁面搜尋功能 */}
        <PageSearch 
          statusList={statusOptionList}
          defaultSearchParams={['pendingUpload']}
          nextAuitor={null}
          onSearchParamsChange={setSearchFilter}
        />
        <Col span={24} style={{ margin:'10px 0px' }} />
        <div
          id="scrollableDiv"
          style={{
            height: 300,
            overflowY: 'auto',
            overflowX: 'hidden',
            // border: '1px solid rgba(140, 140, 140, 0.35)',
            zIndex: 1000
          }}
        >
          <InfiniteScroll
            dataLength={mobileTableData.length}
            next={loadMoreData}
            hasMore={total - mobileTableData.length > 0}
            scrollableTarget="scrollableDiv"
          >
            <List
              dataSource={mobileTableData}
              style={{ background: 'white' }}
              renderItem={(record, index) => {
                return(
                  <>
                    <Row style={{ padding: '10px 0', background: '#71AA1F'}}>
                      <Col span={12} style={{ fontSize: '18px', fontWeight: 'bold', paddingLeft: '16px', color: 'white' }}>
                        編號
                      </Col>
                      <Col span={12} style={{ fontSize: '18px', fontWeight: 'bold', paddingRight: '16px', color: 'white' }}>
                        {record.stamp_no}
                      </Col>
                    </Row>
                    <Row gutter={[ 0, 16 ]} style={{ padding: '10px 16px 0 16px'}}>
                      <Col span={12}>
                        申請人
                      </Col>
                      <Col span={12}>
                        {record.applicant_name}
                      </Col>
                      <Col span={12}>
                        文件名稱
                      </Col>
                      <Col span={12}>
                        {record.document}
                      </Col>
                      <Col span={12}>
                        申請日期
                      </Col>  
                      <Col span={12}>
                        {moment.unix((record.cr_date/1000)).format('YYYY/MM/DD')}
                      </Col>
                      <Col span={12}>
                        狀態
                      </Col>
                      <Col span={12}>
                        {StampStatusObj[record.stamp_status]}
                      </Col>
                      <Divider style={{ margin: '0' }}/>
                      <Row style={{ width: '100%' }} justify='space-evenly'>
                        <a onClick={() => navigate(`/Stamp/StampApplyViewPendingUpload/${record.stamp_no}`)}> 檢視 </a> 
                        {
                          record?.applicant_mail?.toLowerCase() === currentUser?.email?.toLowerCase() ?
                          <>
                            <Divider type='vertical' /><a onClick={() => navigate(`/Stamp/StampTempUpload/${record.stamp_no}`)}> 留存上傳 </a>
                          </>
                          : null
                        }
                        {
                          canRemindUpload(record) ?
                          <>
                            <Divider type='vertical' /><a href={buildReminderMailto(record)}> 跟催 </a>
                            <Divider type='vertical' /><a onClick={() => openReassign(record)}> 轉派 </a>
                          </>
                          : null
                        }
                      </Row>
                      <Divider style={{ margin: '0 0 16px 0' }}/>
                    </Row>
                    <Row style={{ background: '#f6f6f6', height: '20px', margin: '0 0 16px 0' }} />
                  </>
                )
              }}
            />
          </InfiniteScroll>
        </div>
      </MobileView>
      <Modal
        title='轉派給同仁'
        visible={reassignOpen}
        onOk={onReassign}
        onCancel={() => setReassignOpen(false)}
        okText='確定轉派'
        cancelText='取消'
      >
        <p style={{ color: '#7C7C7C' }}>
          將單據 {reassignRecord?.stamp_no} 轉派給部門同仁接手處理，轉派後此單將出現在對方的待處理。
        </p>
        <Select
          showSearch
          style={{ width: '100%' }}
          placeholder='請選擇同仁'
          value={reassignTarget?.value}
          options={allUserList}
          onSelect={(_, option) => setReassignTarget(option)}
          filterOption={(input, option) => {
            if (input.search(/^[A-Za-z0-9]*$/) === 0) {
              return (option?.label ?? '').toLowerCase().startsWith(input.toLowerCase())
            }
            return (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }}
        />
      </Modal>
    </PageLayout>
  )
}
